import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $body = $('body');
const $header = $('.header');
const $hamburger = $('.header__hamburger');
const $close = $('.navigation-menu__close');
const $navMenu = $('.navigation-menu');
const $navMenuTitle = $('.navigation-menu__title');
const $navSubmenuContainer = $('.navigation-submenu__container');
const $navSubmenuLink = $('.navigation-submenu__link');
const $navSubmenuClose = $('.navigation-submenu__close');
const $navMiscLink = $('.navigation-menu-misc__link');
const $searchTrigger = $('.search__trigger');
const swipeTreshold = { x: 100, y: 100 };
const data = {
    startMousePos: { x: -1, y: -1 },
    endMousePos: { x: -1, y: -1 },
};

$(function () {
    $window.on('resize:width', debounce(hideNav, true));
    $hamburger.on('mouseup', function (event) {
        event.stopPropagation();
        toggleNav();
        $('.navigation-menu__close').trigger('focus');
    });
    $hamburger.on('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.stopPropagation();
            toggleNav();
            $('.navigation-menu__close').trigger('focus');
        }
    });
    $close.on('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            hideNav();
            $hamburger.trigger('focus');
        }
        if (event.key === 'Tab' && event.shiftKey) {
            hideNav();
            $hamburger.trigger('focus');
        }
    });
    $close.on('mouseup', function (event) {
        hideNav();
        $hamburger.trigger('focus');
    });
    $close.on('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            hideNav();
            $hamburger.trigger('focus');
        }
    });
    $navMenu.on('keydown', 'a.social__item', function (event) {
        const $this = $(this);
        if (event.key === 'Tab' && !event.shiftKey) {
            if ($this.is(':last-child')) {
                $('.navigation-menu__close').trigger('focus');
            }
        }
    });
    $navMenu.on('mouseup', function (event) {
        if ($navMenu.hasClass('active')) {
            event.stopPropagation();
        }
    });
    $navSubmenuContainer.on('mouseup', function (event) {
        event.stopPropagation();
    });
    $navSubmenuClose
        .on('mouseup', function () {
            hideAllMenus();
        })
        .on('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            hideAllMenus();
        }
        })
        .on('keydown', function (event) {
            if (event.key === 'Tab') {
                hideAllMenus();
            }
        });

    let navMenuTitleClick = false;
    $navMenuTitle
        .on('mouseup', function (event) {
            event.stopPropagation();
        })
        .on('mouseup', function () {
            navMenuTitleClick = true;
            toggleMenu($(this));
        })
        .on('keydown', function (event) {
            if (event.key === 'Enter') {
                toggleMenu($(this));
                navMenuTitleClick = false;
            }
        });

    let navSubmenuLinkClick = false;
    $navSubmenuLink
        .on('mouseup', function (event) {
            event.stopPropagation();
        })
        .on('mouseup', function () {
            navSubmenuLinkClick = true;
            toggleSubMenu($(this));
        })
        .on('keydown', function (event) {
            if (event.key === 'Enter') {
                toggleSubMenu($(this));
                navSubmenuLinkClick = false;
            }
        });

    $body.on('mouseup', hideNav);
    $searchTrigger.on('mouseup', hideNav);
    $navMiscLink.on('mouseup', hideNav);

    $body.on('touchstart', function (event) {
        onTouchStart(event, data);
    });
    $body.on('touchend', function (event) {
        onTouchEnd(event, data);
    });
});

const toggleNav = () => {
    if ($navMenu.hasClass('active')) {
        hideNav();
    } else {
        showNav();
    }
};

const showNav = () => {
    $navMenu.attr('aria-hidden', 'false');
    $navMenu.addClass('active');
    navOverflow();
    $navMenu.on('scroll', navOverflow);
    $window.on('resize:height.navOverflow', debounce(navOverflow));
};

const hideNav = () => {
    $navMenu.scrollTop(0);
    $navMenu.attr('aria-hidden', 'true');
    $navMenu.removeClass('active');
    $navMenu.off('scroll', navOverflow);
    $window.off('resize:height.navOverflow');
    hideAllMenus();
};

const navScrolledTop = () => $navMenu.scrollTop() === 0;
const navScrolledBottom = () =>
    Math.ceil($navMenu.scrollTop() + $navMenu.outerHeight()) >= Math.ceil($navMenu[0].scrollHeight);

const navOverflow = () => {
    if (navScrolledTop() && navScrolledBottom()) {
        $navMenu.addClass('menu-is-up menu-is-down');
    } else {
        if (navScrolledTop()) {
            $navMenu.addClass('menu-is-up');
        } else {
            $navMenu.removeClass('menu-is-up');
        }

        if (navScrolledBottom()) {
            $navMenu.addClass('menu-is-down');
        } else {
            $navMenu.removeClass('menu-is-down');
        }
    }
};

const toggleMenu = (trigger) => {
    const menu = trigger.parent().find('.navigation-submenu');
    if (menu.length !== 0) {
        if (menu.hasClass('active')) {
            hideAllMenus();
        } else {
            showMenu(trigger);
        }
    }
};

const showMenu = (trigger) => {
    hideAllMenus();
    const menu = trigger.parent().find('.navigation-submenu');
    if (menu.length !== 0) {
        if (menu.is(':hidden')) {
            menu.slideDown(300, function () {
                menu.addClass('active');
                navOverflow();
            });
        } else {
            menu.addClass('active');
        }
        trigger.addClass('active');
        $header.addClass('active');
        $navMenuTitle.attr('aria-expanded', 'true');
    }
};

const toggleSubMenu = (trigger) => {
    const menu = trigger.parent().find('.navigation-sub-submenu');
    if (menu.length !== 0) {
        if (menu.hasClass('active')) {
            hideSubMenus();
        } else {
            showSubMenu(trigger);
        }
    }
};

const showSubMenu = (trigger) => {
    hideSubMenus();
    const menu = trigger.parent().find('.navigation-sub-submenu');
    if (menu.length !== 0) {
        if (menu.is(':hidden')) {
            menu.slideDown(300, function () {
                menu.addClass('active');
                navOverflow();
            });
        }
        trigger.addClass('active');
        $navSubmenuLink.attr('aria-expanded', 'true');
    }
};

const hideSubMenus = () => {
    const $activeMenus = $('.navigation-sub-submenu.active');
    $activeMenus.each(function () {
        const $thisEl = $(this);
        const attr = $thisEl.attr('style');
        if (typeof attr !== 'undefined' && attr !== false) {
            $thisEl.slideUp(300, function () {
                $thisEl.removeAttr('style');
                navOverflow();
            });
        }
        $thisEl.removeClass('active');
    });
    $('.navigation-submenu__link.active').removeClass('active');
    $navSubmenuLink.attr('aria-expanded', 'false');
};

const hideAllMenus = () => {
    const $activeMenus = $('.navigation-submenu.active,.navigation-sub-submenu.active');
    $activeMenus.each(function () {
        const $thisEl = $(this);
        const attr = $thisEl.attr('style');
        if (typeof attr !== 'undefined' && attr !== false) {
            $thisEl.slideUp(300, function () {
                $thisEl.removeAttr('style');
                navOverflow();
            });
        }
        $thisEl.removeClass('active');
    });
    $('.navigation-menu__title.active,.navigation-submenu__link.active').removeClass('active');
    $header.removeClass('active');
    $navMenuTitle.attr('aria-expanded', 'false');
};

function onTouchStart(event, data) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.startMousePos.x = touch.pageX;
    data.startMousePos.y = touch.pageY;
}

function onTouchEnd(event, data) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.endMousePos.x = touch.pageX;
    data.endMousePos.y = touch.pageY;

    const mousePosDiff = {
        x: data.startMousePos.x - data.endMousePos.x,
        y: data.startMousePos.y - data.endMousePos.y,
    };

    data.startMousePos = { x: -1, y: -1 };
    data.endMousePos = { x: -1, y: -1 };

    if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
        if (mousePosDiff.x > 0) {
            if ($navMenu.hasClass('active')) {
                hideNav();
            }
        } else {
            if ($(touch.target).closest('.slider').length === 0) {
                if (!$navMenu.hasClass('active')) {
                    showNav();
                }
            }
        }
    }
}
